// extracted by mini-css-extract-plugin
export default {"root":"ListPanel_root__kgcpn","title":"ListPanel_title__K8sPI","value":"ListPanel_value__EGHSn"};